import React, { useState, useEffect, useCallback } from "react";
import { NavLink, Link } from 'react-router-dom';
import axios from 'axios';
import Preloader from '../components/Preloader'

const MobileNav = () => {

  const mobileNavClose = (e) => {
      const mobNavWrap = document.querySelector('.mobile-nav__wrapper');
      const mobNavBody = document.querySelector('body');
      mobNavWrap.classList.remove('expanded');
      mobNavBody.classList.remove('locked');
  };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional, for smooth scrolling
        });
    }; 

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = apiBaseUrl+`services`;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true)

  const fetchPagedata = useCallback(async () => {
    return axios.get(apiUrl).then((res) => {
      console.log(res.data);
      setData(res.data);
    });
  },[]);  

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPagedata();
      setLoading(false);
    }, 1000); // 1 seconds
    return () => clearTimeout(timer);
  }, [fetchPagedata]);    

  return (
    <>
        { loading && ( <Preloader /> )}
        <div className="mobile-nav__wrapper">
            <div className="mobile-nav__overlay mobile-nav__toggler"></div>
            <div className="mobile-nav__content">
                <span className="mobile-nav__close mobile-nav__toggler" onClick={mobileNavClose}><i className="fa fa-times"></i></span>

                <div className="logo-box">
                    <Link to="index.html" aria-label="logo image"><img src="assets/images/logo-light.png" width="155" alt="Logo" /></Link>
                </div>
                <div className="mobile-nav__container">
                            <ul className="main-menu__list">
                                <li><NavLink exact activeClassName="current" to="/" onClick={mobileNavClose}>Home</NavLink></li>
                                <li><NavLink activeClassName="current" to="/about" onClick={mobileNavClose}>About</NavLink></li>
                                <li><NavLink activeClassName="current" to="/why-choose-us" onClick={mobileNavClose}>Why Choose Us</NavLink></li>
                                <li><NavLink activeClassName="current" to="/services" onClick={mobileNavClose}>Services</NavLink></li>
                                <li><NavLink activeClassName="current" to="/portfolio" onClick={mobileNavClose}>Portfolio</NavLink></li>
                                <li><NavLink activeClassName="current" to="/contact" onClick={mobileNavClose}>Contact</NavLink></li>
                            </ul>
                        </div>
                <ul className="mobile-nav__contact list-unstyled">
                    <li>
                        <i className="fa fa-envelope"></i>
                        <Link to="mailto:needhelp@growim.com">contact@digitalkoushik.com</Link>
                    </li>
                    <li>
                        <i className="fa fa-phone-alt"></i>
                        <Link to="tel:+91 84788 61990">+91 84788 61990</Link>
                    </li>
                </ul>
                <div className="mobile-nav__social">
                    <Link to="https://facebook.com">
                        <i className="fab fa-facebook-f" aria-hidden="true"></i>
                        <span className="sr-only">Facebook</span>
                    </Link>
                    <Link to="https://twitter.com">
                        <i className="fab fa-twitter" aria-hidden="true"></i>
                        <span className="sr-only">Twitter</span>
                    </Link>
                    <Link to="https://www.linkedin.com/">
                        <i className="fab fa-linkedin-in" aria-hidden="true"></i>
                        <span className="sr-only">Linkedin</span>
                    </Link>
                    <Link to="https://youtube.com">
                        <i className="fab fa-youtube" aria-hidden="true"></i>
                        <span className="sr-only">Youtube</span>
                    </Link>
                </div>
            </div>
        </div> 

        {data.map((item, index) => {
            return (
            <div className="modal fade" id={`staticBackdrop-${item.id}`} data-bs-backdrop="static" data-bs-keyboard="false" key={index}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="staticBackdropLabel">{item.name}</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">{ item?.description.replace(/<\/?p>/gi, '')}</div>
                    </div>
                </div>
            </div>
            )
        })}


        <Link to="#" data-target="html" className="scroll-to-target scroll-to-top" onClick={scrollToTop}>
            <span className="scroll-to-top__text">back top</span>
            <span className="scroll-to-top__wrapper"><span className="scroll-to-top__inner"></span></span>
        </Link>
    </>
  )
}

export default MobileNav